import { render, staticRenderFns } from "./PreCadastroCliente.vue?vue&type=template&id=562a7a85&scoped=true&"
import script from "./PreCadastroCliente.vue?vue&type=script&lang=js&"
export * from "./PreCadastroCliente.vue?vue&type=script&lang=js&"
import style0 from "./PreCadastroCliente.vue?vue&type=style&index=0&id=562a7a85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a7a85",
  null
  
)

export default component.exports